interface BrandMarkProps {
  size?: number;
  stroke?: string;
  fill?: string;
}

/** The Vibelin mark (three connected circles), shared with website/index.html's nav brand. */
export function BrandMark({ size = 26, stroke = '#a78bfa', fill = '#5b9ef8' }: BrandMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g fill={fill} stroke={stroke}>
        <circle cx="16" cy="6" r="3.4" />
        <circle cx="6" cy="22" r="3.4" />
        <circle cx="26" cy="22" r="3.4" />
        <path d="M16 9.4 8.2 19M16 9.4l7.8 9.6M9.4 22h13.2" strokeWidth={1.6} fill="none" />
      </g>
    </svg>
  );
}
